import React, { useState } from 'react';
import './index.css';
import clsx from 'classnames';
import QueueAnim from 'rc-queue-anim';

const Project = () => {
  const projectList = [
    {
      img: '/img/construction1.png',
      title: '数智实验室建设',
      desc: '结合5G、物联网、大数据、云计算和人工智能为代表的数字技术。围绕实验室人、机、料、法、环五大场景，借助于软硬件一体的数智化管理平台，实现实验室数智化。',
    },
    {
      img: '/img/construction2.jpg',
      title: '温州物资检测中心',
      desc: '承建各网省公司物质及工器具检测试验室；承建各省质检院工器具检测试验室；承建各发电集团工器具及小型施工机具检测试验室',
    },
    {
      img: '/img/construction3.png',
      title: '参与国网项目',
      desc: '参与国网项目——《极端气候条件下输电通道运行可靠性提升关键技术研究》中关于极寒环境下电力器材安全性能验证技术的研究工作。发表核心论文1篇，授权发明专利2项，软件著作权1项。',
    },
  ];
  const [showProjectList, setShowProjectList] = useState(
    projectList.slice(0, 4),
  );

  // 是否需要加载更多
  const isMore =
    showProjectList > 4 || showProjectList.length < projectList.length;

  const onMore = () => {
    if (isMore) {
      setShowProjectList(projectList.slice(0, showProjectList.length + 4));
    }
  };

  return (
    <QueueAnim
      className={clsx('construction-project')}
      type={['bottom', 'top']}
      delay={300}
    >
      <div
        className={clsx('construction-project-title')}
        key='construction-project-title'
      >
        重点项目
      </div>
      <div
        className={clsx('construction-project-list')}
        key='construction-project-list'
      >
        {showProjectList?.map((v, index) => {
          return (
            <div className={clsx('construction-project-list-item')} key={index}>
              <div className={clsx('construction-project-list-item-img')}>
                <img src={v.img} alt='' width={'100%'} height={'100%'} />
              </div>
              <div className={clsx('construction-project-list-item-title')}>
                {v.title}
              </div>
              <div className={clsx('construction-project-list-item-desc')}>
                {v.desc}
              </div>
            </div>
          );
        })}
      </div>
      <div
        className={clsx('construction-project-more')}
        onClick={onMore}
        key='construction-project-more'
      >
        {isMore ? '加载更多' : '没有更多了'}
      </div>
    </QueueAnim>
  );
};

export default Project;
